import annyang from 'annyang';

export const listInstructions = [
	'Say “Add cheese” to add to your list',
	'You can also say “Delete cheese” or “Clear list”',
	'Say “Get recipes” to get some new recipes!',
	'Say “Get favorite recipes” to go to your recipes',
	'Say “Close” to close this window'
];

export const recipesInstructions = [
	'You can say “Bookmark recipe (corresponding recipe number)“',
	'Or “Steps for recipe (corresponding recipe number)“',
	'You can also “Close recipe (corresponding recipe number)“'
];

export const favRecipeInstructions = [
	'Begin by saying “Start cooking recipe (corresponding recipe number)“',
	'You can also “Delete recipe (corresponding recipe number)“'
];

export const singleFavRecipeInstructions = [
	'Say “Yes I am” to get started',
	'You can also say “Next step”',
	'And “Previous step”',
	'Also, “Repeat step”'
];

export const profileInstructions = [ 'Say “sign out” to sign out :(' ];

export const navInstructions = [
	'Say "Get List" to view shopping list.',
	'Say "Get Recipes" to view recipes.',
	'Say "Get Favorite Recipes" to view favorite recipes.'
];

export const greetings = [
	'Alex here',
	'Awaiting Instructions',
	'At your service, Master!',
	'Ready to rumble',
	'Over 9000',
	'For Demacia',
	'give me some orders',
	'Standing by',
	'lets get started',
	'All systems functioning',
	'For the Horde',
	'I am Back'
];

export default annyang;
